export default __webpack_public_path__ + "static/media/jaisalmerdesert.213ec944.jpg";